import { gql } from '@apollo/client'

export const DELETE_REGION = gql`
  mutation DeleteRegion($input: DeleteRegionInput!) {
    deleteRegion(input: $input) {
      deleted
    }
  }
`
